export enum BANKS {
    KHQR = 'khqr',
    KHQR_BAKONG = 'khqr_bakong',
    CREDIT_DEBIT_CARD= 'credit-debit-card',
    ABA= 'ABA',
    CARD = 'card',
    ABA_PAY_KHQR = 'abapay',
    ACLEDA = 'ACLEDA',
    ACLEDA_PAY_KHQR = 'acledapay_khqr',
    LOCAL_BANKS = 'local-banks',
}
